<div class="form-fields-box" [ngClass]="!filter ? 'closed' : ''">
  <h2 (click)="filterBox()"> {{"alerts.alert-edit.title" | translate}} </h2>
  <hr [ngClass]="!filter ? 'hr-open' : ''" />
  @if (loadingAlertData$ | async) {
  <div>
    <p> {{"alerts.alert-edit.loading" | translate}} </p>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
  }

  @if (!(loadingAlertData$ | async)) {
  <mat-accordion>
    <!-- Ordem de serviço  -->
    @if (!alertHasServiceOrder) {
    <mat-expansion-panel [formGroup]="serviceOrderForm">
      <mat-expansion-panel-header>
        <mat-panel-title> {{"alerts.alert-edit.create-OS" | translate}} </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-form-field appearance="outline">
        <mat-label> {{"alerts.alert-edit.create-OS-priority-level" | translate}} </mat-label>
        <mat-select formControlName="priority">
          <mat-option value="LOW"> {{"alerts.alert-edit.create-OS-priority-level-low" | translate}}
          </mat-option>
          <mat-option value="MEDIUM"> {{"alerts.alert-edit.create-OS-priority-level-medium" | translate}}
          </mat-option>
          <mat-option value="HIGH"> {{"alerts.alert-edit.create-OS-priority-level-high" | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label> {{"alerts.alert-edit.create-OS-status" | translate}} </mat-label>
        <mat-select formControlName="status">
          <mat-option value="OPEN"> {{"alerts.alert-edit.create-OS-status-open" | translate}} </mat-option>
          <mat-option value="CLOSED"> {{"alerts.alert-edit.create-OS-status-closed" | translate}}
          </mat-option>
          <mat-option value="IN_PROGRESS"> {{"alerts.alert-edit.create-OS-status-in-progress" | translate}}
          </mat-option>
          <mat-option value="CLOSED_WITH_ISSUES">
            {{"alerts.alert-edit.create-OS-status-closed-width-issues" | translate}}
          </mat-option>
          <mat-option value="DELETED"> {{"alerts.alert-edit.create-OS-deleted" | translate}} </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label> {{"alerts.alert-edit.reference" | translate}} </mat-label>
        <input matInput formControlName="reference" name="reference" type="text" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label> {{'alerts.alert-edit.create-OS-assignee' | translate}} </mat-label>
        <input formControlName="searchAssignee" matInput
          placeholder=" {{'alerts.alert-edit.create-OS-assignee' | translate}} " #reference />
        <mat-icon class="component-search-icon" (click)="searchAssignee(reference.value)">
          search
        </mat-icon>
      </mat-form-field>
      @if (isLoadingAssignee) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @if (userList.length > 0) {
      <mat-form-field appearance="outline">
        <mat-label>
          {{'alerts.alert-edit.select-option' | translate}}
        </mat-label>
        <mat-select formControlName="assignee" [value]="userList[0].id">
          @for (user of userList; track user) {
          <mat-option apperance="outline" [value]="user.id">
            {{ user?.username }}
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
      }
      @if (isLoadingCreateServiceOrder) {
      <mat-spinner [diameter]="30"></mat-spinner>
      }
      @if (!isLoadingCreateServiceOrder) {
      <button class="btn btn-primary w-100" (click)="createServiceOrder()">
        {{"alerts.alert-edit.button-create-OS" |
        translate}} </button>
      }
    </mat-expansion-panel>
    }
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        @if (!alertHasServiceOrder) {
        <mat-panel-title>
          {{"alerts.alert-edit.link-OS" | translate}}
        </mat-panel-title>
        }
        @if (alertHasServiceOrder) {
        <mat-panel-title>
          {{"alerts.alert-edit.OS-linked" | translate}}
        </mat-panel-title>
        }
      </mat-expansion-panel-header>
      @if (serviceOrdersLoading$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      <mat-form-field appearance="outline">
        <mat-label> {{'alerts.alert-edit.search-OS' | translate}} </mat-label>
        <input matInput placeholder=" {{'alerts.alert-edit.search-OS' | translate}}" #reference />
        <mat-icon class="component-search-icon" (click)="filterServiceOrderByReference(reference.value)">
          search
        </mat-icon>
      </mat-form-field>
      @if (!alertHasServiceOrder) {
      <span class="d-flex align-items-center">
        @if (!(serviceOrdersLoading$ | async)) {
        <mat-form-field label appearance="outline">
          <mat-label> {{"alerts.alert-edit.select-OS" | translate}} </mat-label>
          <mat-select #matRef>
            @for (serviceOrder of serviceOrders$ | async; track serviceOrder) {
            <mat-option [value]="serviceOrder.id" (click)="setSelectedOsInformation(serviceOrder)">
              {{ serviceOrder.reference }} ({{ serviceOrder.status }})
              {{ serviceOrder.creationDate | date : "dd/MM/yyyy" }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        }
        @if (selectedOsInformation) {
        <mat-icon class="cancel-icon" (click)="clearOsSelection()">cancel</mat-icon>
        }
      </span>
      }
      @if (loadingSelectedOsInformation) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @if (!loadingSelectedOsInformation && selectedOsInformation?.reference!= null ) {
      <div class="os-info">
        @if (!alertHasServiceOrder) {
        <p> {{"alerts.alert-edit.data-OS" | translate}}</p>
        }
        <div class="row mt-2">
          <span class="col-xl-7 col-lg-6 col-md-4 col-sm-3"><strong> {{"alerts.alert-edit.OS-creation-date" |
              translate}}
            </strong>
            {{ selectedOsInformation?.creationDate }}</span>
          <mat-divider></mat-divider>
          <span class="col-xl-7 col-lg-6 col-md-4 col-sm-3"><strong> {{"alerts.alert-edit.OS-status"|
              translate}}
            </strong> {{
            selectedOsInformation?.status
            }}
          </span>
          <mat-divider></mat-divider>
          <span class="col-xl-7 col-lg-6 col-md-4 col-sm-3"><strong> {{"alerts.alert-edit.OS-installation" |
              translate}}
            </strong>
            {{ selectedOsInformation?.installation }}
          </span>
          <mat-divider></mat-divider>
          <span class="col-xl-7 col-lg-6 col-md-4 col-sm-3"><strong> {{"alerts.alert-edit.OS-created-by" |
              translate}}
            </strong>
            {{ selectedOsInformation?.user }}
          </span>
          <mat-divider></mat-divider>
          <span class="col-xl-7 col-lg-6 col-md-4 col-sm-3"><strong> {{"alerts.alert-edit.assigned-to" |
              translate }}
            </strong>
            {{ selectedOsInformation?.assignee?.username }}
          </span>
          <mat-divider></mat-divider>
          <span class="col-12"><strong> {{"alerts.alert-edit.reference" | translate}} </strong> {{
            selectedOsInformation?.reference }}
          </span>
        </div>
      </div>
      }
      @if (!alertHasServiceOrder) {
      <button class="btn btn-primary w-100" [disabled]="!selectedOsInformation" (click)="addServiceOrderToAlert()">
        {{"alerts.alert-edit.OS-button" | translate}}
      </button>
      }
    </mat-expansion-panel>
  </mat-accordion>
  }

  <button class="btn btn-primary mt-2" [disabled]="loadingAlertData$ | async" (click)="cancelEdit()">
    {{"alerts.alert-edit.OS-button-back" | translate}}
  </button>
</div>